// States (ISO 3166-2 subdivisions) are only asked for United States addresses (FOYS-26217).
export const US_COUNTRY_ID = 840;

function loadStates(locale) {
    try {
        return require(`./locales/states/${locale}`);
    } catch {
        // Locales without their own list (e.g. de-DE, fr-FR) show the English names.
        return require("./locales/states/en-GB");
    }
}

export const stateHelper = {
    computed: {
        // [{ countryCode, code, name }] in the current locale.
        states() {
            return loadStates(this.$i18n.locale);
        },
        stateOptions() {
            return this.states.map((x) => ({ id: x.code, name: x.name }));
        },
    },
    methods: {
        // The name of a stored state code; the code itself when the list does not know it.
        getStateNameByCode(code) {
            if (!code) return null;
            const state = this.states.find((x) => x.code === String(code).toUpperCase());
            return state ? state.name : code;
        },
    },
};
